import { useQuery } from 'react-query'

import { useUserOrganization } from '@modules-deprecated/app/organization'

import { QueryKeys } from '../../../enums/queryKeys'
import { fetchSalesVatRatesWithRules } from '../query-api'

export const useFetchSalesVatRatesWithRules = () => {
  const { organization } = useUserOrganization()
  const { data, ...rest } = useQuery(
    QueryKeys.SalesVatRatesWithRules,
    () => fetchSalesVatRatesWithRules(organization?.id || ''),
    {},
  )

  return { rules: data?.rules, taxRates: data?.taxRates || [], ...rest }
}
